import { ServerlessStorageFile } from "@/service/serverless-gpu/type";

type FileItem = {
  name: string;
  size: number;
  type: string;
  modified: string;
  fullPath: string;
  children?: FileItem[];
}

export const transformToTreeStructure = (files: ServerlessStorageFile[]): FileItem[] => {
  const root: FileItem[] = [];
  
  // สร้าง Map เพื่อเก็บ reference ของแต่ละ path
  const pathMap = new Map<string, FileItem>();
  // สร้าง Map เพื่อเก็บขนาดรวมของแต่ละโฟลเดอร์
  const folderSizeMap = new Map<string, number>();

  // สร้างโครงสร้างต้นไม้
  files.forEach(file => {
    const paths = file.path_name.split('/').filter(Boolean);
    let currentPath = '';
    let currentLevel = root;

    // สร้างโฟลเดอร์ตามเส้นทาง
    for (let i = 0; i < paths.length; i++) {
      const name = paths[i];
      const isFile = i === paths.length - 1;
      currentPath = currentPath ? `${currentPath}/${name}` : name;
      
      if (!pathMap.has(currentPath)) {
        const newItem: FileItem = {
          name,
          size: isFile ? file.size : 0, // ตั้งค่าเริ่มต้นเป็น 0 สำหรับโฟลเดอร์
          type: isFile ? file.type : 'directory',
          modified: file.last_modified,
          fullPath: currentPath,
          children: []
        };

        pathMap.set(currentPath, newItem);
        currentLevel.push(newItem);
        currentLevel = newItem.children!;
      } else {
        currentLevel = pathMap.get(currentPath)!.children!;
      }

      // เพิ่มขนาดไฟล์ให้กับโฟลเดอร์ทุกระดับที่เกี่ยวข้อง
      if (isFile) {
        // สร้างเส้นทางย่อยทั้งหมดเพื่อปรับปรุงขนาดของโฟลเดอร์แต่ละระดับ
        let folderPath = '';
        for (let j = 0; j < i; j++) {
          folderPath = folderPath ? `${folderPath}/${paths[j]}` : paths[j];
          folderSizeMap.set(folderPath, (folderSizeMap.get(folderPath) || 0) + file.size);
        }
      }
    }
  });

  // อัปเดตขนาดของโฟลเดอร์ทั้งหมด
  folderSizeMap.forEach((size, path) => {
    const folder = pathMap.get(path);
    if (folder) {
      folder.size = size;
    }
  });

  // ลบ children array ที่ว่างเปล่า
  const cleanupEmptyChildren = (items: FileItem[]) => {
    items.forEach(item => {
      if (item.children?.length === 0) {
        delete item.children;
      } else if (item.children) {
        cleanupEmptyChildren(item.children);
      }
    });
  };

  cleanupEmptyChildren(root);
  return root;
};
